import React from "react";
import { usePendingDelay } from "../hooks/usePendingDelay";
import { PendingContent } from "../shared/PendingDots";

interface PrimaryButtonProps {
  icon?: React.ReactNode;
  text?: string;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  /** HTML button type. Defaults to "submit" for backward compatibility. */
  type?: "button" | "submit" | "reset";
  /** When true the button is disabled and marked busy; after the pending delay its label is replaced by the pending dots. */
  loading?: boolean;
  /** Accessible label for screen readers when the visible text is insufficient. */
  ariaLabel?: string;
}

const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  icon,
  text,
  onClick,
  className = "",
  disabled = false,
  type = "submit",
  loading = false,
  ariaLabel,
}) => {
  const isDisabled = disabled || loading;
  const showDots = usePendingDelay(loading);

  return (
    <button
      onClick={onClick}
      className={className}
      type={type}
      disabled={isDisabled}
      aria-label={ariaLabel}
      aria-busy={loading || undefined}
    >
      <PendingContent showDots={showDots}>
        {icon && <span className={text ? "gcw:m-2" : undefined}>{icon}</span>}
        {text}
      </PendingContent>
    </button>
  );
};

export default PrimaryButton;
